module.exports = __webpack_public_path__ + "static/media/login.1309deaa.mp4";